<script setup lang="ts">
import { computed } from 'vue'

import { Icon } from '@/shared/ui/icon'
import { PlatformLogo, resolveStaticPlatformLogo } from '@/shared/ui/logo'
import type { SelectOptionVisual } from '@/shared/ui/select'

const props = withDefaults(
  defineProps<{
    visual?: SelectOptionVisual | undefined
    label?: string
    size?: number
  }>(),
  { visual: undefined, label: '', size: 16 },
)

const logoSrc = computed(
  () => props.visual?.logoSrc || resolveStaticPlatformLogo(props.visual?.platform),
)
</script>

<template>
  <span
    v-if="visual?.icon || visual?.platform"
    class="ui-option-visual inline-flex flex-none items-center gap-2xs"
    aria-hidden="true"
  >
    <Icon v-if="visual.icon" :name="visual.icon" weight="light" :size="size" />
    <PlatformLogo
      v-if="visual.platform"
      :platform="visual.platform"
      :channel="visual.channel ?? null"
      :alt="label"
      :size="size"
      v-bind="logoSrc ? { src: logoSrc } : {}"
    />
  </span>
</template>
